/**
 * Page Renderer Component
 * 
 * Renders PageDoc JSON content from the visual editor.
 * This is a read-only renderer for displaying published views.
 * Uses the same rendering logic as the PreviewRenderer for consistency.
 */

import React from 'react';
import { PreviewRenderer } from './PreviewRenderer';
import { PageDoc } from '../../types/page-builder.types';

interface PageRendererProps {
  pageDoc: PageDoc;
  organizationId: string;
  teamId?: string;
}

export const PageRenderer: React.FC<PageRendererProps> = ({
  pageDoc,
  organizationId,
  teamId,
}) => {
  // Check if we have valid content to render
  if (!pageDoc || !pageDoc.layout) {
    return (
      <PreviewRenderer
        pageDoc={{
          ...pageDoc,
          layout: [],
        }}
        showPageFrame={false}
        maxWidth="xl"
      />
    );
  }

  // Use the PreviewRenderer which already handles all the styling and layout correctly
  // This ensures consistency between the editor preview and the final rendered view
  return (
    <PreviewRenderer
      pageDoc={pageDoc}
      showPageFrame={false}
      maxWidth="xl"
    />
  );
};

export default PageRenderer;